import React from 'react';
import { Alert } from '@mui/material';
import type { StripeExpressOpenFailure } from 'utils/stripeExpressLink';

type Props = {
  failure: StripeExpressOpenFailure | null;
  /** Screen-scoped automation prefix, e.g. "talent-invoice-modal". */
  testIdPrefix: string;
};

/** T2-7437: why Stripe Express did not open, and a direct link when the browser blocked the tab. */
export default function StripeExpressOpenError({ failure, testIdPrefix }: Props) {
  if (!failure) return null;
  return (
    <Alert
      severity="error"
      data-testid={`${testIdPrefix}-stripe-open-error`}
      sx={{
        mt: 2,
        backgroundColor: 'rgba(251, 118, 114, 0.12)',
        color: '#0B4598',
        '& .MuiAlert-icon': { color: '#FB7672' },
      }}
    >
      {failure.message}
      {failure.url && (
        <div>
          <a
            href={failure.url}
            target="_blank"
            rel="noopener noreferrer"
            className="external no-fastclick"
            data-testid={`${testIdPrefix}-stripe-open-link`}
          >
            Open Stripe Express
          </a>
        </div>
      )}
    </Alert>
  );
}
